import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 bg-[#424E60] text-white py-3 px-4 text-center shadow-md" data-id="element-39">
      <p className="text-sm md:text-base font-bold flex items-center justify-center gap-2 flex-wrap" data-id="element-40">
        <span data-id="element-41">⏳ OFERTA EXPIRA EN:</span>
        <CountdownTimer variant="small" data-id="element-42" />
        <span className="hidden md:inline" data-id="element-43">|</span>
        <span className="text-yellow-300" data-id="element-44">🔥 CUPOS LIMITADOS</span>
      </p>
    </div>;
}